import { showSetupModal } from './../actions/index';
import { ACTIONS } from '../actions/index';
import { stateType } from '../../types/index';


function getLocalStorageItem(key: string, defaultValue: number): number {
  const storedValue = localStorage.getItem(key);
  if (storedValue) {
    try {
      return JSON.parse(storedValue);
    } catch (e) {
      console.error('Error parsing JSON from localStorage', e);
      return defaultValue;
    }
  }
  return defaultValue;
}

const initialState = {
  login: false,
  loading: false,
  openModal: {},
  userInfo: {},
  pageSettings: {
    useFilter: true,
    pageTitle: ''
  },
  filter: {

  },
  combos: {
    universities: [],
    courses: []
  },
  showSetupModal: false,
  // profileScore: 0
    profileScore: getLocalStorageItem('profileScore', 0),
}

const appReducer = (state = initialState, action: any): stateType => {
  switch (action.type) {
    case ACTIONS.LOGIN:
      return { ...state, login: action.login }
    case ACTIONS.LOADING:
      return { ...state, loading: action.loading }
    case ACTIONS.OPENMODAL:
      return { ...state, openModal: action.openModal }
    case ACTIONS.USERINFO:
      return { ...state, userInfo: action.userInfo }
    case ACTIONS.PAGE:
      return { ...state, pageSettings: action.pageSettings }
    case ACTIONS.FILTER:
      return { ...state, filter: action.filter }
    case ACTIONS.COMBO:
      return { ...state, combos: action.combos }
   case ACTIONS.SHOW_SETUP_MODAL:
    return { ...state, showSetupModal: action.payload };
    case ACTIONS.SET_PROFILE_SCORE:
      return {
        ...state,
        profileScore: action.payload
      };
  }

  
  return state;
}


export default appReducer;